export default {
      id: "menu__notifications_fill-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__notifications_fill",
      toString: function () {
        return this.url;
      }
    }